import React, { useState } from "react";
import UnauthorizedPage from "../../UnauthorizedPage";
import EndpointGroupTable from "./EndpointGroupTable";
import EndpointTypeTable from "./EndpointTypeTable";
import EndpointDetailsTable from "./EndpointDetailsTable";

export default function EndpointConfig() {
  const [error, setError] = useState(null);
  if(error == 'Unauthorized'){
    return (
      <UnauthorizedPage/>
    )
  }
  return (
    <div className="p-4  bg-gradient-to-b from-[#003366]/5 to-white  ">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <EndpointGroupTable error={error} setError={setError}/>
        <EndpointTypeTable error={error} setError={setError}/>
      </div>
      <div className="mt-4">
        <EndpointDetailsTable error={error} setError={setError}/>
      </div>
    </div>
  );
}
